import { IApplicationState } from '../../types/redux';

export function getReliableData(state: IApplicationState) {
  return state.developer.reliable;
}
